import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-feedback-thanks-modal',
  templateUrl: './feedback-thanks-modal.component.html',
  styleUrls: ['./feedback-thanks-modal.component.scss'],
  standalone: false
})
export class FeedbackThanksModalComponent implements OnInit {
  
  @Input() stars: number = 5;
  
  messages: string[] = [
    'Tu opinión nos ayuda a mejorar cada día',
    'Tu feedback es muy valioso para nosotros',
    'Gracias por tomarte el tiempo de valorarnos',
    'Con tu ayuda seguimos mejorando',
    'Tu valoración marca la diferencia'
  ];
  
  selectedMessage: string = '';

  constructor(private modalController: ModalController) { }

  ngOnInit(): void {
    // Seleccionar un mensaje aleatorio
    const randomIndex = Math.floor(Math.random() * this.messages.length);
    this.selectedMessage = this.messages[randomIndex];
    
    // Cerrar automáticamente después de 2.5 segundos
    setTimeout(() => {
      this.close();
    }, 2500);
  }

  close(): void {
    this.modalController.dismiss();
  }
}
